import { Link } from "react-router-dom";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Sparkles, ArrowRight } from "lucide-react";
import PageHead from "@/components/PageHead";

interface Props {
  title: string;
  description?: string;
  highlights?: string[];
}

export default function ComingSoon({ title, description, highlights }: Props) {
  return (
    <>
      <PageHead title={`${title} | WeKIT Education Intelligence`} description={description ?? `${title} — coming soon`} path="/schools" />
      <div className="container max-w-4xl py-14">
        <Card className="border-dashed">
          <CardContent className="p-10 md:p-14 text-center space-y-6">
            <div className="mx-auto w-14 h-14 rounded-2xl bg-primary/10 text-primary grid place-items-center">
              <Sparkles className="w-6 h-6" />
            </div>
            <div className="space-y-2">
              <div className="inline-flex items-center gap-2 text-xs font-medium text-primary uppercase tracking-wider">
                Coming in the next phase
              </div>
              <h1 className="text-3xl md:text-4xl font-semibold tracking-tight">{title}</h1>
              {description && (
                <p className="text-muted-foreground max-w-xl mx-auto leading-relaxed">{description}</p>
              )}
            </div>
            {highlights && highlights.length > 0 && (
              <ul className="grid sm:grid-cols-2 gap-3 max-w-2xl mx-auto text-left pt-2">
                {highlights.map((h) => (
                  <li key={h} className="flex items-start gap-3 rounded-xl border bg-muted/30 px-4 py-3 text-sm">
                    <span className="w-1.5 h-1.5 rounded-full bg-primary mt-2 shrink-0" />
                    <span>{h}</span>
                  </li>
                ))}
              </ul>
            )}
            <div className="flex items-center justify-center gap-2 pt-4">
              <Button asChild variant="default">
                <Link to="/schools">Back to Overview <ArrowRight className="w-4 h-4 ml-1" /></Link>
              </Button>
              <Button asChild variant="ghost">
                <Link to="/start">Try the student experience</Link>
              </Button>
            </div>
          </CardContent>
        </Card>
      </div>
    </>
  );
}
